/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'printer': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M18 3H6v4h12m1 5a1 1 0 01-1-1 1 1 0 011-1 1 1 0 011 1 1 1 0 01-1 1m-3 7H8v-5h8m3-6H5a3 3 0 00-3 3v6h4v4h12v-4h4v-6a3 3 0 00-3-3z"/>'
  }
})
